const ADMIN_EMAILS = ['admin@nexriseindia.in', 'hr@nexriseindia.in'];
const OPS_MANAGER_EMAILS = ['opsheadniipl@gmail.com'];
const WAREHOUSE_EMAILS = ['warehouse.niipl@gmail.com'];

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();
const isAdminEmail = (email) => ADMIN_EMAILS.includes(normalizeEmail(email));
const isOpsManagerEmail = (email) => OPS_MANAGER_EMAILS.includes(normalizeEmail(email));
const isWarehouseEmail = (email) => WAREHOUSE_EMAILS.includes(normalizeEmail(email));

export const normalizeRole = (role) => String(role || '').trim().toLowerCase();

export const resolveUserRole = (userData = {}, email = '') => {
  const normalizedStoredRole = normalizeRole(userData.role);

  if (isAdminEmail(email)) {
    return 'admin';
  }

  if (isOpsManagerEmail(email)) {
    return 'ops_manager';
  }

  if (isWarehouseEmail(email)) {
    return 'warehouse';
  }

  if (normalizedStoredRole === 'ops_manager') {
    return 'ops_manager';
  }

  if (normalizedStoredRole === 'warehouse') {
    return 'warehouse';
  }

  return normalizedStoredRole || 'sales';
};

export const isSalesManager = (user) => normalizeRole(user?.role) === 'sales_manager';

export const isSalesUser = (user) => ['sales', 'sales_manager'].includes(normalizeRole(user?.role));

export const isOpsManager = (user) => normalizeRole(user?.role) === 'ops_manager';

export const isWarehouseUser = (user) => normalizeRole(user?.role) === 'warehouse';

export const isOpsUser = (user) => ['ops', 'ops_manager', 'warehouse'].includes(normalizeRole(user?.role));

export const isAccountsUser = (user) => normalizeRole(user?.role) === 'accounts';

export const isAdminUser = (user) => normalizeRole(user?.role) === 'admin';

export const hasOrderApprovalAccess = (user) => isSalesManager(user);

export const hasMocApprovalAccess = (user) => isOpsManager(user);

export const canCreateSalesDocuments = (user) => isSalesUser(user);

export const canAccessQuotes = (user) => isSalesUser(user) || isAdminUser(user) || isSalesManager(user);

export const canAccessInvoices = (user) => isSalesUser(user) || isAdminUser(user) || isSalesManager(user);

export const canAccessOrders = (user) => isSalesUser(user) || isOpsUser(user) || isAdminUser(user) || isSalesManager(user);

export const canAccessConfirmedOrders = (user) => isSalesUser(user) || isOpsUser(user) || isAdminUser(user) || isSalesManager(user);

export const canSelfApproveOrders = (user) => isSalesManager(user);

export const getOrderSubmissionStatus = (user) => {
  if (isSalesManager(user)) return 'in_que';
  if (normalizeRole(user?.role) === 'sales') return 'pending_approval';
  return 'confirmed_order';
};

export const canSearchCollection = (user, collectionName) => {
  if (isOpsUser(user)) {
    return collectionName === 'orders';
  }

  if (isAccountsUser(user)) {
    return ['accounts_invoices', 'accounts_transactions'].includes(collectionName);
  }

  if (isAdminUser(user)) {
    return ['quotes', 'invoices', 'orders', 'accounts_invoices', 'accounts_transactions'].includes(collectionName);
  }

  if (isSalesUser(user)) {
    return ['quotes', 'invoices', 'orders'].includes(collectionName);
  }

  return false;
};
